import { Component, input, computed } from "@angular/core";
import { RouterLink } from "@angular/router";
import { EvGridTableModule, ITableLayoutModel, ITableHeader, BaseListComponent } from "ev-grid-table";
import { NearbySiteSaleDto } from "src/models/sales/nearby-site-sales.model";
import { CommonModule } from "@angular/common";
import { EVEstateType } from "src/models/units/unit-attributes.model";
import { EvTooltipModule } from "ev-tooltip";
import { ThousandizePipe, UnitPipe } from "ev-core";
import { DefaultConverterPipe } from "src/app/shared/pipes/defaultconverter.pipe";

@Component({
    selector: "nearby-site-sales",
    templateUrl: "./nearby-site-sales.component.html",
    styleUrl: "./nearby-site-sales.component.scss",
    imports: [EvGridTableModule, CommonModule, EvTooltipModule, ThousandizePipe, DefaultConverterPipe, UnitPipe, RouterLink],
})
export class NearbySiteSalesComponent extends BaseListComponent<NearbySiteSaleDto> {
    nearbySiteSales = input.required<NearbySiteSaleDto[]>();

    originalData = computed(() => this.nearbySiteSales() || []);

    EVEstateType = EVEstateType;

    constructor() {
        super();
    }

    protected createHeaders(): ITableHeader[] {
        return [
            {
                name: "Dato",
                prop: "publicRegistrationDate",
                desc: true,
                type: "date",
                isSortable: true,
            },
            {
                name: "Adresse",
                prop: "concatenatedAddress",
                desc: true,
                type: "text",
                isSortable: true,
            },
            {
                name: "Tomtetype",
                prop: "ownershipType",
                desc: true,
                type: "text",
                isSortable: true,
            },
            {
                name: "Areal",
                prop: "siteArea",
                desc: true,
                type: "number",
                isSortable: true,
            },
            {
                name: "m²-pris",
                prop: "squareMeterPrice",
                desc: true,
                type: "number",
                isSortable: true,
            },
            {
                name: "Pris",
                prop: "price",
                type: "number",
                desc: true,
                isSortable: true,
            },
        ];
    }

    protected createDisplayTemplate(): ITableLayoutModel {
        return {
            breakPoints: [
                {
                    gridAreas:
                        '"estate-type-icon siteArea price" "concatenatedAddress concatenatedAddress concatenatedAddress" "publicRegistrationDate publicRegistrationDate publicRegistrationDate" "ownershipType ownershipType ownershipType" "squareMeterPrice squareMeterPrice squareMeterPrice"',
                    gridColumns: "40px 100px 110px",
                    maxWidth: 623,
                },
                {
                    gridAreas:
                        '"estate-type-icon publicRegistrationDate ownershipType siteArea squareMeterPrice price" "concatenatedAddress concatenatedAddress concatenatedAddress concatenatedAddress concatenatedAddress concatenatedAddress"',
                    gridColumns: "40px 100px 130px 100px 90px 110px",
                    maxWidth: 800,
                },
                {
                    gridAreas: '"estate-type-icon publicRegistrationDate concatenatedAddress ownershipType siteArea squareMeterPrice price"',
                    gridColumns: "40px 100px 1fr 130px 100px 90px 110px",
                },
            ],
        };
    }
}
